import { Eye, Server as ServerIcon, Brain, MessageSquare, Hand, Heart, Shield, Mic, Headphones, Anchor } from 'lucide-react'

const pillars = [
  { id: 'vision', name: 'Vision', role: 'Cloudflare', icon: Eye, status: 'online', color: 'text-aith-cyan', services: ['Workers AI', 'AI Gateway', 'R2', 'D1', 'KV'], tasks: 1 },
  { id: 'stomach', name: 'Stomach', role: 'DigitalOcean', icon: ServerIcon, status: 'online', color: 'text-aith-green', services: ['LobeHub', 'Ollama', 'Nextcloud'], tasks: 1 },
  { id: 'brains', name: 'Brains', role: 'HuggingFace', icon: Brain, status: 'online', color: 'text-aith-purple', services: ['Models', 'Inference', 'Datasets'], tasks: 2 },
  { id: 'mouth', name: 'Mouth', role: 'Tencent', icon: MessageSquare, status: 'offline', color: 'text-aith-yellow', services: ['SMS', 'WeChat', 'Voice'], tasks: 0 },
  { id: 'hands', name: 'Hands', role: 'GitHub', icon: Hand, status: 'online', color: 'text-gray-300', services: ['Repos', 'Actions', 'Codespaces'], tasks: 0 },
  { id: 'heart', name: 'Heart', role: 'AWS', icon: Heart, status: 'unknown', color: 'text-aith-red', services: ['EC2 (aithai)', 'Unknown'], tasks: 0 },
  { id: 'shield', name: 'Shield', role: 'Google Cloud', icon: Shield, status: 'offline', color: 'text-aith-accent', services: ['Security', 'Knowledge', 'Storage'], tasks: 1 },
  { id: 'voice', name: 'Voice', role: 'Alibaba', icon: Mic, status: 'online', color: 'text-aith-orange', services: ['ECS Muscle', 'Bangkok'], tasks: 0 },
  { id: 'ears', name: 'Ears', role: 'n8n / Flowise', icon: Headphones, status: 'offline', color: 'text-gray-400', services: ['Automation', 'Workflows'], tasks: 0 },
  { id: 'legs', name: 'Legs', role: 'Azure', icon: Anchor, status: 'offline', color: 'text-aith-accent', services: ['R&D', 'DevOps', 'Knees'], tasks: 0 },
]

function StatusDot({ status }) {
  const classes = {
    online: 'bg-aith-green shadow-[0_0_6px_rgba(16,185,129,0.6)]',
    offline: 'bg-aith-red',
    unknown: 'bg-aith-yellow',
  }
  return <span className={`w-2 h-2 rounded-full inline-block ${classes[status] || classes.unknown}`} />
}

export default function PillarGrid() {
  return (
    <div>
      <h2 className="text-xs font-bold tracking-widest text-gray-500 uppercase mb-4">10 Digital Body Pillars</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        {pillars.map((pillar) => {
          const Icon = pillar.icon
          return (
            <div key={pillar.id} className="panel hover:border-aith-accent/50 transition-colors cursor-pointer group">
              <div className="flex items-start justify-between mb-3">
                <div className={`p-2 rounded bg-gray-800/50 ${pillar.color}`}>
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex items-center gap-2">
                  {pillar.tasks > 0 && (
                    <span className="text-[9px] font-bold text-aith-orange bg-aith-orange/10 px-1.5 py-0.5 rounded border border-aith-orange/20">
                      {pillar.tasks} task{pillar.tasks > 1 ? 's' : ''}
                    </span>
                  )}
                  <StatusDot status={pillar.status} />
                </div>
              </div>
              <h3 className="text-sm font-bold text-white mb-0.5">{pillar.name}</h3>
              <p className="text-[10px] text-gray-500 mb-2">{pillar.role}</p>
              <div className="flex flex-wrap gap-1">
                {pillar.services.map((s) => (
                  <span key={s} className="text-[9px] px-1.5 py-0.5 bg-gray-800 rounded text-gray-400 border border-gray-700">
                    {s}
                  </span>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
